import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import isEmpty from 'lodash-es/isEmpty';
import * as qs from "qs";
@Injectable({
  providedIn: 'root',
})
export class FilterPageService {
  constructor(private route: ActivatedRoute) {}

  /**
   * Gets the custom external query params (the ones not utilized directly by the app)
   *
   * @returns {*}
   * @memberof FilterPageService
   */
  getExternalQueryParams(stringify: boolean = false): any {
    const externalParams: any = {};
    Object.keys(this.route.snapshot.queryParams)
      .filter(
        (key: string) => key !== 'filters' && key !== 'toggle' && key !== 'sort' && key !== 'page'
      )
      .forEach((key: string) => (externalParams[key] = this.route.snapshot.queryParamMap.get(key)));

    if (isEmpty(externalParams)) {
      return null;
    }

    if (stringify) {
      return qs.stringify(externalParams);
    }

    return externalParams;
  }

  /**
   * Translate a feature display value to a param value
   * 
   * @param feature 
   * @returns "difyProductNumber" | "printtotheedge" | "cleanEdge" | '' 
   */
  featuresFilterToBrowser(feature: string): "difyProductNumber" | "printtotheedge" | "cleanEdge" | ''{
    if (feature === 'WePrint') return 'difyProductNumber';
    if (feature === 'Print to the Edge') return 'printtotheedge';
    if (feature === 'Clean Edge') return 'cleanEdge';
    return '';
  }

  /**
   * Translate a feature param to a display value
   * 
   * @param feature 
   * @returns 'WePrint' | 'Print to the Edge' | 'Clean Edge' | '' 
   */
  featuresFilterFromBrowser(feature: string): 'WePrint' | 'Print to the Edge' | 'Clean Edge' | '' {
    if (feature === 'difyProductNumber') return 'WePrint';
    if (feature === 'printtotheedge') return 'Print to the Edge'
    if (feature === 'cleanEdge') return 'Clean Edge';
    return '';
  }
}
